import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ReviewDetailItem from "./ReviewDetailItem";
import styles from "../../styles/proposal/reviewCard.module.css";
import { ExpandMoreOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";

type ReviewsType = {
  no_assessments: number;
  assessments: {
    assessment_question_id: number;
    assessment_question_name: string;
    items: reviewType[];
  }[];
};

type reviewType = {
  assessment_note: string;
  assessment_rating: number;
};

const ReviewCard = (props: ReviewsType) => {
  const auditability_reviews = props.assessments[0];
  const feasibility_reviews = props.assessments[1];
  const impact_reviews = props.assessments[2];

  return (
    <Accordion
      defaultExpanded
      elevation={4}
      sx={{ borderRadius: "10px", marginTop: "20px" }}
    >
      <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
        <Typography variant="h5"> Reviews </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{ display: "flex", gap: "10px", flexDirection: "column" }}
      >
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreOutlined />}
            className={styles.reviewSummary}
          >
            {`AUDITABILITY (${props.no_assessments}) `}
          </AccordionSummary>
          <AccordionDetails>
            {auditability_reviews.items.map((review, index) => (
              <ReviewDetailItem
                key={index}
                rating={review.assessment_rating}
                note={review.assessment_note}
              />
            ))}
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreOutlined />}
            className={styles.reviewSummary}
          >
            {`FEASIBILITY (${props.no_assessments}) `}
          </AccordionSummary>
          <AccordionDetails>
            {feasibility_reviews.items.map((review, index) => (
              <ReviewDetailItem
                key={index}
                rating={review.assessment_rating}
                note={review.assessment_note}
              />
            ))}
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreOutlined />}
            className={styles.reviewSummary}
          >
            {`IMPACT (${props.no_assessments}) `}
          </AccordionSummary>
          <AccordionDetails>
            {impact_reviews.items.map((review, index) => (
              <ReviewDetailItem
                key={index}
                rating={review.assessment_rating}
                note={review.assessment_note}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      </AccordionDetails>
    </Accordion>
  );
};

export default ReviewCard;
